import { render, staticRenderFns } from "./ManageApplicant.vue?vue&type=template&id=65ac2e3a&"
import script from "./ManageApplicant.vue?vue&type=script&lang=js&"
export * from "./ManageApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports